export function setBadgeCount(_count: number): Promise<void> {
  return Promise.resolve()
}
